import { render, staticRenderFns } from "./blacklistManagement.vue?vue&type=template&id=10e44582&scoped=true&"
import script from "./blacklistManagement.vue?vue&type=script&lang=js&"
export * from "./blacklistManagement.vue?vue&type=script&lang=js&"
import style0 from "./blacklistManagement.vue?vue&type=style&index=0&id=10e44582&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e44582",
  null
  
)

export default component.exports